import { render, staticRenderFns } from "./TypeRestriction.vue?vue&type=template&id=6827f387&"
import script from "./TypeRestriction.vue?vue&type=script&lang=js&"
export * from "./TypeRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports